import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!
  const _component_InputError = _resolveComponent("InputError")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_VueMultiselect, _mergeProps({ class: "default" }, _ctx.$attrs, {
      modelValue: _ctx.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
      options: _ctx.options,
      showLabels: false
    }), null, 16, ["modelValue", "options"]),
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(_component_InputError, { msg: _ctx.errors }, null, 8, ["msg"])
    ], 512), [
      [_vShow, _ctx.isInvalid]
    ])
  ], 64))
}